// material-ui
import { createTheme } from '@mui/material/styles';

// third-party
import { presetPalettes } from '@ant-design/colors';

// project import
import ThemeOption from './theme/index';
import { useSelector } from 'react-redux';
import { SettingsState, Store } from '../store/types';

// ==============================|| DEFAULT THEME - PALETTE  ||============================== //

const Palette = () => {
    const { mode, branding } = useSelector<Store, SettingsState>(
        state => state.settings,
    );
    const isDarkMode = (mode ?? 'light') === 'dark';

    const colors = presetPalettes;

    let greyPrimary, greyAscent;

    if (isDarkMode) {
        greyPrimary = [
            '#181818',
            '#202020',
            '#282828',
            '#383838',
            '#404040',
            '#585858',
            '#606060',
            '#686868',
            '#707070',
            '#787878',
            '#808080',
        ];

        greyAscent = ['#6b6b6b', '#4b4b4b', '#282828', '#212121'];
    } else {
        greyPrimary = [
            '#ffffff',
            '#fafafa',
            '#f5f5f5',
            '#f0f0f0',
            '#d9d9d9',
            '#bfbfbf',
            '#8c8c8c',
            '#595959',
            '#262626',
            '#141414',
            '#000000',
        ];

        greyAscent = ['#fafafa', '#bfbfbf', '#434343', '#1f1f1f'];
    }

    const greyConstant = ['#fafafb', '#e6ebf1'];

    colors.grey = [...greyPrimary, ...greyAscent, ...greyConstant];

    const paletteColor = ThemeOption(
        colors,
        branding?.primaryColor,
        branding?.secondaryColor,
    );

    return createTheme({
        palette: {
            mode,
            common: {
                black: '#000',
                white: '#fff',
            },
            ...paletteColor,
            text: {
                primary: isDarkMode ? '#fff' : '#000',
                secondary: isDarkMode ? '#ccc' : '#383838',
                disabled: isDarkMode ? '#969696' : '#bebebe',
            },
            action: {
                disabled: isDarkMode ? '#969696' : '#494949',
            },
            divider: paletteColor.grey[200],
            background: {
                paper: isDarkMode ? '#282828' : '#fdfdfd',
                default: isDarkMode ? '#000' : '#f1f1f1',
            },
        },
    });
};

export default Palette;
